var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"actions-list"},_vm._l((_vm.list),function(item){return _c('ActionsCardComponent',{key:item.id,attrs:{"content":item},on:{"showAction":_vm.showActionHandler}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }